import { format } from 'date-fns/fp';
import { pipe } from 'ramda';

import { parseStringToDate } from '../../../utils/days-generator/helpers';
import { TCalendarDay } from '../types';

type Day = Pick<TCalendarDay, 'dayNumber'>;

export const parseAndFormatDate = pipe(parseStringToDate, format('MMM d, EEE'));

export const checkIsHoverInitial = (() => {
  let _prevState: Day = { dayNumber: -1 };

  const checkIsAnotherDay = (nextDay: Day) => {
    return _prevState.dayNumber !== nextDay.dayNumber;
  };

  return (day: Day) => {
    if (!_prevState || checkIsAnotherDay(day)) {
      _prevState = day;
      return true;
    }

    return false;
  };
})();
